import { Store } from 'library/ts/utilities//Store';
import * as CompareModule from 'library/ts/utilities/compare/';
import { Importer } from 'library/ts/utilities/Importer';
import { IImporter } from 'library/ts/utilities/interfaces/IImporter';
import { ISessionStore } from 'library/ts/utilities/interfaces/ISessionStore';
import { IStore } from 'library/ts/utilities/interfaces/IStore';
import { Loader } from 'library/ts/utilities/Loader';
import { LogService } from 'library/ts/utilities/logger/LogService';
import * as API from 'library/ts/utilities/modules/API';
import * as ArrayModule from 'library/ts/utilities/modules/Array';
import * as CalcModule from 'library/ts/utilities/modules/Calc';
import * as ConvertModule from 'library/ts/utilities/modules/Convert';
import { Conveyor } from 'library/ts/utilities/conveyor';
import * as CSSModule from 'library/ts/utilities/modules/CSS';
import * as DateModule from 'library/ts/utilities/modules/Date';
import * as DeepMerge from 'library/ts/utilities/modules/DeepMerge';
import * as Delay from 'library/ts/utilities/modules/Delay';
import * as DOMModule from 'library/ts/utilities/modules/DOM';
import * as EventModule from 'library/ts/utilities/modules/Event';
import * as FullScreenModule from 'library/ts/utilities/modules/FullScreen';
import * as FunctionModule from 'library/ts/utilities/modules/Function';
import * as GAM from 'library/ts/utilities/modules/GAM';
import * as HDCPModule from 'library/ts/utilities/modules/HDCP';
import * as Hotkeys from 'library/ts/utilities/modules/Hotkeys';
import * as ImportModule from 'library/ts/utilities/modules/Import';
import * as NumberModule from 'library/ts/utilities/modules/Number';
import * as ObjectModule from 'library/ts/utilities/modules/Object';
import * as PromiseModule from 'library/ts/utilities/modules/Promise';
import * as StringModule from 'library/ts/utilities/modules/String';
import * as TypeModule from 'library/ts/utilities/modules/Type';
import * as URLModule from 'library/ts/utilities/modules/URL';
import SessionStore from 'library/ts/utilities/SessionStore';

/**
 * @copyright © Paramount Streaming
 * @author Stan Gletski
 * @description All Utilities in one singleton
 */
export class Utilities {

	public static _name: string = 'Utilities';
	private static _instance: Utilities = new Utilities();
	/**
	 * @description Name of this class
	 * @type {String}
	 */
	name: string = 'Utilities';
	/**
	 * @description Array operations library
	 */
	Array = ArrayModule;
	/**
	 * @description Calculations library
	 */
	Calc = CalcModule;
	/**
	 * @description CSS operations library
	 */
	CSS = CSSModule;
	/**
	 * @description Comparison operations library
	 */
	Compare = CompareModule;
	/**
	 * @description Conversion operations library
	 */
	Convert = ConvertModule;
	/**
	 * @description Object transformation pipeline factory function
	 * @example Utilities.Conveyor('my-key').transformer(fn) or Utilities.Conveyor('my-key').process(obj)
	 */
	Conveyor = Conveyor;
	/**
	 * @description Date operations library
	 */
	Date = DateModule;
	/**
	 * @description DOM operations library
	 */
	DOM = DOMModule;
	/**
	 * @description HDCP related utilities
	 */
	HDCP = HDCPModule;
	/**
	 * @description Event operations library
	 */
	Event = EventModule;
	/**
	 * @description Full Screen operations library
	 */
	FullScreen = FullScreenModule;
	/**
	 * @description Function operations library
	 */
	Function = FunctionModule;
	/**
	 * @description Code / images import operations library
	 */
	Import = ImportModule;
	/**
	 * @description Number operations library
	 */
	Number = NumberModule;
	/**
	 * @description Object operations library
	 */
	Object = ObjectModule;
	/**
	 * @description Promise operations library
	 */
	Promise = PromiseModule;
	/**
	 * @description String operations library
	 */
	String = StringModule;
	/**
	 * @description Type checking library
	 */
	Type = TypeModule;
	/**
	 * @description URL operations library
	 */
	URL = URLModule;
	/**
	 * @description DeepMerge library
	 */
	DeepMerge = DeepMerge;
	/**
	 * @description Timeout, interval operations
	 */
	Delay = Delay;
	/**
	 * @description Hotkeys library
	 */
	Hotkeys = Hotkeys;
	/**
	 * @description Google Ad Manager utilities
	 */
	GAM = GAM;
	/**
	 * @description API utilities
	 */
	API = API;
	/**
	 * @description Loader reference
	 */
	Loader = Loader;
	/**
	 * @description Importer reference
	 */
	Importer: IImporter;
	/**
	 * @description Store instance
	 */
	Store: IStore = Store.getInstance();
	/**
	 * @description SessionStore instance
	 */
	SessionStore: ISessionStore = SessionStore.getInstance();
	/**
	 * @description Log Service
	 */
	Log = LogService;

	constructor() {
		if ( Utilities._instance ) {
			throw new Error( Utilities._name + ' is a Singleton and can only be accessed through ' + Utilities._name + '.getInstance()' );
		}
		Utilities._instance = this;
		// create instance of Importer
		this.Importer = new Importer();
	}

	public static getInstance(): Utilities {
		return Utilities._instance;
	}

}